import React from "react";
import StickyScroller from "./StickyScroller";

const whyItems = [
  {
    title: "Leveraging the Cloud",
    description:
      "We decrease the time to provision IT infrastructure, speeding delivery of projects critical to revenue growth.",
  },
  {
    title: "Advanced Analytics",
    description:
      "Personalized experiences, informed decision making, streamlined operations, risk mitigation, and enhanced security.",
  },
  {
    title: "Access Anywhere",
    description:
      "Monitor and control access to systems anywhere, anytime. Support employees, partners, and customers on the go.",
  },
  {
    title: "Collaboration",
    description:
      "We extend your team — embracing a problem-solving approach and opening new channels of communication.",
  },
  {
    title: "Flexibility & Agility",
    description:
      "Reducing time-to-market with rapid expansion capability and adaptation to new market conditions.",
  },
  {
    title: "Learning Culture",
    description:
      "Continuous upskilling built into our engineering practice, ensuring developers stay current with the latest technologies.",
  },
];

export default function WhyChooseUs() {
  return (
    <StickyScroller
      side="right"
      eyebrow="Why teams stay"
      title="Why Leading Businesses Choose Us"
      description="We combine technical expertise, industry experience, and a client-first approach to deliver innovative solutions that drive lasting business success."
      accent="#6d28d9"
      items={whyItems}
      renderBadge={(_, i) => i + 1}
    />
  );
}